export default __webpack_public_path__ + "static/media/location-step.8b7730f5.svg";